import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getScheduleDelay';

export const getScheduleDelay = (params) => {
    return network.post(ENDPOINT, params).then((response) => response.data);
};
